export default __webpack_public_path__ + "static/media/boardroom_lg.7b0977c1.jpg";